/**
 * クリックしたら消える
 **/
(function($) {
  'use strict';

  $('.hide-me').on('click', function (e) {
    var target = $(this).data('target');
    if ( target ) {
      console.log(target);
      $(target).show();
    }
    $(this).hide();
  });

})(jQuery);
